import { display } from '@mui/system';
import React from 'react';

const PlanOption = ({ plan, isSelected, onSelect }) => {
  // console.log('plan: ', plan);
  const handleCardClick = () => {
    if (!isSelected) {
      onSelect();
    }
  };
  //${plan.isBestDeal ? 'best-deal' : ''}    duration: "12 Months",
  return (
    <div
      className={`plan ${isSelected ? "selected" : ""} `}
      onClick={handleCardClick}>
      <div className="part duration-part">
        <input
          type="radio"
          id={`plan${plan.count}`}
          name="plan"
          value={plan.count}
          checked={isSelected}
          onChange={onSelect}
          style={{
            width:"50%"
          }}
        />
        <label htmlFor={`plan${plan.count}`} className="duration">
        {plan.count} <br /> {`${plan.type == "year" ? "Year" : "Casting Call"}`}
        </label>
      </div>
      <div className="part price-part">
        {/* <span className="original-price">${plan.originalPrice}</span> */}
        <span className="price">${plan.price}</span>
        {/* <span className="per-month">per month</span> */}
      </div>
       
    </div>
  );
};

export default PlanOption;
